import React from 'react';
import AdminPage from '../../components/admin/AdminPage';
import useProjectSearchTags from './hooks/useProjectSearchTags';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import { Controller } from 'react-hook-form';
import { IProjectSearchTags } from './models/projectModel';
import { useParams } from 'react-router-dom';
import LoadingCard from '../../components/LoadingCard';

interface Props {
  id: string;
  searchTags: IProjectSearchTags | null;
}

const ProjectSearchTags = () => {
  const pageName = 'Administrar Tags de Búsqueda';
  const { id: investorProjectId = '' } = useParams();

  const {
    project,
    onChangeSearchType,
    control,
    handleSubmit,
    errors,
    reset,
    onSubmit,
  } = useProjectSearchTags({
    id: investorProjectId,
  });

  if (!project) {
    return <LoadingCard name={pageName} parent_name="Cargando..." />;
  }

  return (
    <AdminPage name={pageName} parentName={`${project.code} - ${project.name}`}>
      <Row className="">
        <Col xs={12} md={8} lg={6}>
          <Card>
            <CardBody>
              <CardTitle tag="h4" className="mb-4">
                Configuración de Tags de Búsqueda
              </CardTitle>
              {/* Visor de tags existentes */}
              <div className="mb-4">
                <strong style={{ fontSize: '1.05rem' }}>Tags actuales:</strong>
                <div className="" style={{ fontSize: '1rem' }}>
                  <div className="mb-1">
                    <span className="fw-semibold">Lugares:</span>{' '}
                    {project.search_tags?.places &&
                    project.search_tags.places.length > 0 ? (
                      project.search_tags.places.join(', ')
                    ) : (
                      <span className="text-muted">Sin datos</span>
                    )}
                  </div>
                  <div>
                    <span className="fw-semibold">Características:</span>{' '}
                    {project.search_tags?.characteristics &&
                    project.search_tags.characteristics.length > 0 ? (
                      project.search_tags.characteristics.join(', ')
                    ) : (
                      <span className="text-muted">Sin datos</span>
                    )}
                  </div>
                </div>
              </div>
              <Form
                onSubmit={handleSubmit(async (data) => {
                  await onSubmit(data);
                  reset();
                })}
              >
                <FormGroup>
                  <Label for="search_type">Tipo de búsqueda</Label>
                  <Controller
                    name="search_type"
                    control={control}
                    render={({ field }) => (
                      <Input
                        type="select"
                        id="search_type"
                        {...field}
                        invalid={!!errors.search_type}
                        onChange={(event) => {
                          field.onChange(event); // react-hook-form update
                          onChangeSearchType(event); // precarga el input
                        }}
                      >
                        <option value="">Selecciona una opción...</option>
                        <option value="places">Lugares</option>
                        <option value="characteristics">Características</option>
                      </Input>
                    )}
                  />
                  {errors.search_type && (
                    <FormFeedback>{errors.search_type.message}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label for="values">Valores (Texto separado por comas)</Label>
                  <Controller
                    name="values"
                    control={control}
                    render={({ field }) => (
                      <Input
                        type="text"
                        id="values"
                        placeholder="Ejemplo: playa, montaña, centro"
                        {...field}
                        invalid={!!errors.values}
                      />
                    )}
                  />
                  {errors.values && (
                    <FormFeedback>{errors.values.message}</FormFeedback>
                  )}
                </FormGroup>
                <div className="d-flex justify-content-end">
                  <Button color="primary" type="submit">
                    Guardar tags
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </AdminPage>
  );
};

export default ProjectSearchTags;
